import { App } from 'antd';
import { useDeleteTopic } from '@/hooks/useTopics';

export function useConfirmDeleteTopic() {
  const { message, modal } = App.useApp();
  const mut = useDeleteTopic();
  return (topic: { id: string; details: { title?: Record<string, string> } }) =>
    new Promise<boolean>((resolve) => {
      const title = topic.details.title?.en ?? topic.id;
      modal.confirm({
        title: `Delete topic "${title}"?`,
        content: 'This permanently removes the topic. Attachments are not deleted.',
        okText: 'Delete',
        okButtonProps: { danger: true },
        onOk: async () => {
          try {
            await mut.mutateAsync(topic.id);
            message.success('Deleted');
            resolve(true);
          } catch (e) {
            message.error((e as Error).message);
            resolve(false);
          }
        },
        onCancel: () => resolve(false),
      });
    });
}
